// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3ikxd","name":"ConsentHeader_name__2dhzt","birthday":"ConsentHeader_birthday__74aD1","skeleton":"ConsentHeader_skeleton__3Qql9"};